import {verboseLogging} from '../config/environment';

// This Middleware is for managing multiple asynchronous calls where you are only interested in the latest one sent.
// The flow is that the Action Method first calls getNextVersion to get a version number, and then adds this as the
// "asyncVersion" field of the resulting Action Object. The Action Object will get rejected if its version is not the
// current version.

const VERSION_MAP = {};

export const getNextVersion = (actionType) => {
  if (!VERSION_MAP[actionType]) {
    VERSION_MAP[actionType] = 0;
  }
  return ++VERSION_MAP[actionType];
};

export const asyncManager = _store => next => action => {
  const currentVersion = VERSION_MAP[action.type];
  if (currentVersion) {
    if (action.asyncVersion !== currentVersion) {
      if (verboseLogging) {
        console.log(
          'Discarding an action of type ' +
            action.type +
            '. Action Version = ' +
            action.asyncVersion +
            '. Current Version = ' +
            currentVersion
        );
      }
      return;
    }
  }

  return next(action);
};



// WEBPACK FOOTER //
// ./src/middleware/asyncManagerMiddleware.js